import { ParsedUrlQuery } from 'querystring';

export function getBedsMax(query: ParsedUrlQuery) {
    if (query['beds_max']) {
        return query['beds_max'];
    }

    return '';
}
